const CARD_TOKENIZATION_GA_CATEGORIES = {
  CARD_MANAGEMENT_PAGE_LOAD: 'page_load_card_managemnt_page',
  PAGE_LOAD_ADD_CARD: 'page_load_add_card'
};
const CARDS_ISSUING_GA_CATEGORIES = {
  SHOW_BTN: 'show_button'
};

const CARD_ISSUING_ACTIVATE_GA_CATEGORIES = {
  VIEW_PIN_PAGE_LOAD: 'view_pin_page_load',
  VIEW_PIN_SUCCESSFUL: 'view_pin_success',
  VIEW_PIN_FAILED: 'view_pin_failure',
  ACTIVATE_CARD_ISSUING_SUCCESS: 'activate_card_cta_success',
  ACTIVATE_CARD_ISSUING_FAILURE: 'activate_card_cta_failure'
};

const SUBSCRIPTION_GA_CATEGORIES = {
  SUBSCRIPTION_START_NO_TRIAL: 'subscription_submit_no_trial',
  SUBSCRIPTION_START_WITH_TRIAL: 'subscription_submit_with_trial',
  SUBSCRIPTION_SHOW_DETAILS_NO_TRIAL: 'subscription_show_details_no_trial',
  SUBSCRIPTION_SHOW_DETAILS_WITH_TRIAL: 'subscription_show_details_with_trial'
};

const DEMO_GA_CATEGORIES = {
  SIGN_UP_CLICK: 'sign_up_click',
  EXPLORE_DOCS: 'explore_the_docs_click',
  OPEN_SHARE_DEMO_MODAL: 'open_share_demo_modal',
  OPEN_TEST_CARDS_MODAL: 'open_test_cards_modal',
  SUBMIT_CARD_SUCCESS: 'payment_submit_card_success',
  SUBMIT_CARD_FALIED: 'payment_submit_card_failure',
  SUBMIT_CARD_AUTH: 'payment_submit_card_authentication'
};

const TOOLKIT_GA_CATEGORIES = {
  MOBILE_VIEW: 'mobile_view',
  SAVE_CARD_DEFAULT: 'save_card_default',
  HIDE_CART_ITEMS: 'hide_cart_items',
  HIDE_ORDER_DETAILS: 'hide_order_details',
  HIDE_SUBMIT_BUTTON: 'hide_submit_button',
  WAIT_ON_PAYMENT_CONFIRMATION: 'wait_on_payment_confirmation',
  CLOSE_ON_COMPLETE: 'close_on_complete',
  WAIT_ON_PAYMENT_REDIRECT: 'wait_on_payment_redirect'
};

export const GA_ACTIONS = {
  CLICK: 'Click',
  SELECT: 'Select',
  SET_DEFAULT: 'select_default_card',
  ERROR: 'Error',
  DELETE: 'Delete',
  CLOSE: 'Close',
  SAVE: 'Save',
  FINISH: 'Finish',
  REDIRECT: 'Redirect',
  REQUIRED_FIELDS_UPDATE: 'Required Fields Update',
  REQUIRED_FIELDS_ERROR: 'Required Fields Error',
  VALIDATIONS_ERRORS: 'Validation Errors',
  API_ERROR: 'API Error',
  OPEN: 'Open',
  FAILURE: 'Failure',
  SUCCESS: 'Success',
  PENDING: 'Pending',
  DETECTED: 'Detected',
  PAGE_LOAD: 'Page load',
  PAGE_LOAD_THANK_YOU: 'page_load_thankyou',
  PAGE_LOAD_SAVED_CARDS: 'page_load_saved_cards',
  ADD_NEW_CARD: 'add_new_card',
  SEARCH: 'Search',
  MAKE_ANOTHER_PAYMENT: 'Make another payment',
  SAVE_CARD: 'submit_save_card',
  DELETE_CARD: 'delete_card',
  SAVE_BENEFICIARY: 'submit_save_beneficiary',
  SELECT_POMT: 'selected_pomt',
  SUBSCRIPTION_SUMMARY: 'mobile_subscription_summary',
  PAYMENT_SUMMERY: 'mobile_payment_summary',
  T_AND_C: 't&c_privacy_policy',
  LANG_PICKER: 'language_picker',
  APPLE_PAY: 'applepay_payment',
  GOOGLE_PAY: 'googlepay_payment',
  SELECTED_PMT: 'selected_pmt',
  EXPANDED_CONTENT_PAGE_LOAD: 'expanded_content_page_load',
  EXPANDED_CONTENT_CLOSE: 'expanded_content_close',
  EDIT_SAVED_CARD: 'edit_saved_card_mode',
  CARD_ABSTRACTION: 'card_abstraction',
  BILLING_ADDRESS_FIELDS_LOAD: 'billing_address_fields_load',
  SELECT_IDV: 'selected_Identity_document',
  CUSTOMER_SUPPORT: 'Customer support'
};

export const GA_CATEGORIES = {
  PAGE_LOAD: 'page_load',
  OTP_PAGE_LOAD: 'OTP_page_load',
  PAYOUT_TRACKER_PAGE_LOAD: 'payout_tracker_page_load',
  PAYMENT_LINK_PAGE_LOAD: 'payment_link_page_load',
  THANK_YOU_PAGE_LOAD: 'thank_you_page_load',
  RESET_PIN_PAGE_LOAD: 'reset_pin_page_load',
  ACTIVATE_CARD_PAGE_LOAD: 'activate_card_page_load',
  Activate_card_success: 'activate_card_success',
  CHECKED: 'checked',
  PAYMENT_METHOD_CATEGORY: 'pmt_category',
  TOOLTIP: 'Tooltip',
  LANGUAGE_PICKER: 'Language Picker',
  T_AND_C: 'Terms and Conditions',
  ERRORS: 'Errors',
  API_ERROR: 'Api Error Message',
  OTP_FAILURE: 'OTP_failure',
  OTP_SUCCESS: 'OTP_success',
  RESET_PIN_CLICK: 'reset_pin_link_click',
  RESET_PIN_SUCCESS: 'reset_pin_success',
  RESET_PIN_FAILURE: 'reset_pin_failure',
  PAYMENT_SUBMIT: 'payment_submit',
  PAYMENT_LINK_SUBMIT: 'proceed_to_payment',
  SUBMIT: 'Submit',
  BACK_TO_WEBSITE: 'Back to website',
  BACK_BUTTON: 'Back Button',
  REQUIRED_FIELDS: 'Required fields',
  PAYMENT_METHOD_OPTIONS: 'Payment method options',
  THANK_YOU: 'Thank-you page',
  GENERAL_ERROR_MESSAGE: 'General Error Message',
  ARE_YOU_SURE_POPUP: 'Are you sure popup',
  ERROR_500: 'Error code 500 page',
  START_VERIFICATION: 'Start verification button',
  SELFIE: 'Selfie',
  IDENTITY_DOCUMENT: 'Identity document',
  TAKE_PICTURE_MODAL: 'Take picture modal',
  DELETE_PICTURE_MODAL: 'Delete picture modal',
  VERIFY_IDV: 'Confirm button',
  ALERT_ERROR_MESSAGE: 'Alert Error Message',
  RETAKE_IMAGE: 'Update photo - mobile',
  CAMERA_PHOTO_SUBMISSION: 'Camera - photo submission',
  CAMERA_MOBILE: 'Camera - mobile',
  CAMERA_ERROR: 'Open camera - error',
  URL_CSS_INJECTION: 'url-css-injection',
  NUMBER_OF_CARDS: 'number of cards',
  ...CARD_TOKENIZATION_GA_CATEGORIES,
  ...CARDS_ISSUING_GA_CATEGORIES,
  ...CARD_ISSUING_ACTIVATE_GA_CATEGORIES,
  ...SUBSCRIPTION_GA_CATEGORIES,
  ...DEMO_GA_CATEGORIES,
  ...TOOLKIT_GA_CATEGORIES
};

export const GA_LABEL = {
  CATEGORY_CHANGED: 'pmt category changed',
  PAYMENT_SUCCESS: 'Payment is successful',
  DIGITAL_WALLET: 'digital wallet',
  FORM_NOT_VALID: 'Form not valid',
  SUCCESS: 'Success',
  FAILURE: 'Failure',
  PENDING: 'Pending',
  REUSABLE_IS_EDITABLE: 'Amount_isEditable',
  REUSABLE_WITH_DESCRIPTION: 'withDescription',
  PHONE: 'phoneNumber',
  EMAIL: 'email',
  SUPPORT_URL: 'help center url'
};

export enum GaDimensionNaming {
  INTEGRATION_TYPE = 'integration_type',
  MERCHANT_ID = 'merchant_id',
  MERCHANT_NAME = 'merchant_name',
  PAYOUT_CATEGORY = 'payout_category',
  IS_VALITOR = 'is_valitor'
}
